export default __webpack_public_path__ + "static/media/017-American football.df858121.svg";